import { Dialog, DialogContent } from '@shared/components/ui/dialog'
import { Button } from '@shared/components/ui/button'
import { Check } from 'lucide-react'

interface CheckoutSuccessModalProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  checkoutName: string
}

export function CheckoutSuccessModal({
  open,
  onOpenChange,
  checkoutName
}: CheckoutSuccessModalProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md gap-6 rounded-2xl p-8">
        <div className="flex justify-center">
          <div className="flex h-16 w-16 items-center justify-center rounded-full bg-primary/10">
            <Check className="h-8 w-8 text-primary" />
          </div>
        </div>

        <div className="space-y-2 text-center">
          <h2 className="text-2xl font-semibold">Checkout page created</h2>
          <p className="text-sm text-muted-foreground">
            <span className="font-medium text-foreground">{checkoutName || 'Your checkout page'}</span> is ready
            to accept payments. You can find and manage it in your checkout pages list.
          </p>
        </div>

        <Button
          onClick={() => onOpenChange(false)}
          className="h-12 w-full"
        >
          Done
        </Button>
      </DialogContent>
    </Dialog>
  )
}
